export const AppointmentMissedIcon: React.FC<any> = ({ className }) => {
    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{
                __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="inherit">
        <g clip-path="url(#clip0_999_2515)">
          <path d="M18 5.25V6H0V5.25C0 3.18225 1.68225 1.5 3.75 1.5H4.5V0.75C4.5 0.336 4.836 0 5.25 0C5.664 0 6 0.336 6 0.75V1.5H12V0.75C12 0.336 12.336 0 12.75 0C13.164 0 13.5 0.336 13.5 0.75V1.5H14.25C16.3177 1.5 18 3.18225 18 5.25ZM18 7.5V14.25C18 16.3177 16.3177 18 14.25 18H3.75C1.68225 18 0 16.3177 0 14.25V7.5H18ZM10.0605 12.75L11.7802 11.0302C12.0735 10.737 12.0735 10.263 11.7802 9.96975C11.487 9.6765 11.013 9.6765 10.7198 9.96975L9 11.6895L7.28025 9.96975C6.987 9.6765 6.513 9.6765 6.21975 9.96975C5.9265 10.263 5.9265 10.737 6.21975 11.0302L7.9395 12.75L6.21975 14.4697C5.9265 14.763 5.9265 15.237 6.21975 15.5303C6.366 15.6765 6.558 15.75 6.75 15.75C6.942 15.75 7.134 15.6765 7.28025 15.5303L9 13.8105L10.7198 15.5303C10.866 15.6765 11.058 15.75 11.25 15.75C11.442 15.75 11.634 15.6765 11.7802 15.5303C12.0735 15.237 12.0735 14.763 11.7802 14.4697L10.0605 12.75Z" fill="inherit"/>
        </g>
        <defs>
          <clipPath id="clip0_999_2515">
            <rect width="18" height="18" fill="inherit"/>
          </clipPath>
        </defs>
      </svg>
    `,
            }}
        />
    )
}
